import React, {Suspense, lazy} from "react";
import {Route, Switch} from "react-router-dom";
import {withAuth0} from "@auth0/auth0-react";
import {connect} from "react-redux";
import {setUserInfo} from "../../../redux/actions/themeActions";
import PrivateRoute from "./PrivateRoute";

const MainPage = lazy(() => import("../../index"));
const PostPage = lazy(() => import("../../Post/Post"));

class Routes extends React.Component {
    async componentDidUpdate(prevProps, prevState, snapshot) {
        const {auth0: {isAuthenticated, getAccessTokenSilently}} = this.props;

        if (prevProps.auth0.isAuthenticated !== isAuthenticated && isAuthenticated) {
            const token = await getAccessTokenSilently();
            sessionStorage.setItem("authorizationToken", token);
        }
    }

    render() {
        return (
            <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                    <PrivateRoute exact path="/" component={MainPage}/>
                    <PrivateRoute exact path="/posts" component={PostPage}/>
                </Switch>
            </Suspense>
        );
    }
}

const withAuth = withAuth0(Routes);

export default connect(null, {setUserInfo})(withAuth);